import { FontAwesome5 } from '@expo/vector-icons';
import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';

import { OEText } from '../../atoms';

interface StepCircleProps {
  completed?: boolean;
  active?: boolean;
  stepNumber: number;
  horizontal?: boolean;
}

export function StepCircle({
  stepNumber,
  active,
  completed,
  horizontal,
}: StepCircleProps) {
  return (
    <Container stepNumber={stepNumber} horizontal={horizontal}>
      <Circle
        stepNumber={stepNumber}
        active={active}
        completed={completed}
        horizontal={horizontal}
      >
        {completed ? (
          <Icon size={horizontal ? 10 : 12} />
        ) : (
          <Number active={active} horizontal={horizontal}>
            {stepNumber}
          </Number>
        )}
      </Circle>
    </Container>
  );
}

interface ContainerProps {
  stepNumber: number;
  horizontal?: boolean;
}

interface CircleProps {
  completed?: boolean;
  active?: boolean;
  stepNumber: number;
  horizontal?: boolean;
}

interface NumberProps {
  active?: boolean;
  horizontal?: boolean;
}

const Container = styled.View<ContainerProps>`
  background-color: ${({ theme: { color }, horizontal }) =>
    horizontal ? color.background : 'transparent'};
  justify-content: center;
  align-items: center;
  height: ${({ horizontal }) => (horizontal ? 24 : 32)}px;
  width: ${({ horizontal }) => (horizontal ? 24 : 32)}px;
`;

const getSize = ({ completed, horizontal }: CircleProps) => {
  if (horizontal) return completed ? 18 : 24;
  return completed ? 24 : 32;
};
const Circle = styled.View<CircleProps>`
  width: ${(props) => getSize(props)}px;
  height: ${(props) => getSize(props)}px;
  border-radius: 40px;
  border: 1px solid
    ${({ theme: { color }, active, completed }) =>
      active || completed ? color.accent : color.border};
  background-color: ${({ theme: { color }, completed }) =>
    completed ? color.accent : color.background};
  align-items: center;
  justify-content: center;
`;

const Icon = styled(FontAwesome5).attrs(({ theme: { color } }) => ({
  name: 'check',
  color: color.background,
}))``;

const Number = styled(OEText).attrs({
  fontFamily: secondaryFontFamily,
})<NumberProps>`
  font-size: ${({ horizontal }) => (horizontal ? 16 : 20)}px;
  color: ${({ theme: { color }, active }) =>
    active ? color.accent : color.dark3};
  font-weight: 700;
  line-height: ${({ horizontal }) => (horizontal ? 18 : 24)}px;
`;
